import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { trackEvent } from "../util/analytics.ts";
import { EventCategory } from "@labs/shared/types/EventCategory.ts";
import { useTheme } from "@mui/material/styles";

const GuidedTour = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Stack spacing={4} margin={theme.spacing(8, 0, 24, 0)}>
      <Typography
        variant={"h3"}
        color={"primary.contrastText"}
        align={"center"}
      >
        Guided Tour
      </Typography>

      <Typography
        variant={"body1"}
        color={"primary.contrastText"}
        align={"center"}
      >
        Our decarbonization experts will walk you through a 30-minute emissions
        reduction planning process. This service is free during the beta release
        of this planner.
      </Typography>
      <Stack direction={"row"} spacing={4} justifyContent={"center"}>
        <Button
          variant={"outlined"}
          color={"secondary"}
          onClick={() => navigate(-1)}
        >
          Return
        </Button>
        <Button
          variant={"contained"}
          color={"secondary"}
          href={
            "https://outlook.office.com/owa/calendar/EmissionsReductionPlanning@CascadeEnergyInc.onmicrosoft.com/bookings/"
          }
          target={"_blank"}
          onClick={() => {
            trackEvent(
              EventCategory.Feedback,
              "Clicked Schedule Link",
              window.location.href,
            );
          }}
        >
          Book an Appointment
        </Button>
      </Stack>
    </Stack>
  );
};

export default GuidedTour;
